module.exports = __webpack_public_path__ + "img/slots_online-1.a33c419d.png";